// extracted by mini-css-extract-plugin
export default {"header":"AdminSupportPanel_header__Q2KqK"};